import { CLIENT_ID_LOGIN, CLIENT_STATE_LOGIN } from '../../../hooks/constants';

export type { ActionsModel, InitialStateModel } from './types';

export const loginRedirection =()=>{
  const baseUrl = process.env.REACT_APP_BACKEND_URL

  localStorage.setItem('login_redirection', window.location.pathname);
  window.location.href=`https://id.${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/bm/ident/auth?client_id=${CLIENT_ID_LOGIN}&redirect_uri=https://${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/loginresponse&response_type=code&state=${CLIENT_STATE_LOGIN}&country=DE#/`;
}
